import store from "../../../store";
import {
  setIsLiveMsg,
  setIsLiveMsgNotification,
} from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";

/* ============================================================
   GLOBAL STATE
============================================================ */
let socket = null;
let isConnecting = false;
let heartbeatInterval = null;
let reconnectTimeout = null;
let messageQueue = [];

const HEARTBEAT_INTERVAL = 30 * 1000; // 30 seconds (AWS safe)
const RECONNECT_DELAY = 2000;

/* ============================================================
   HEARTBEAT
============================================================ */
const startHeartbeat = () => {
  if (heartbeatInterval) return;

  heartbeatInterval = setInterval(() => {
    if (socket?.readyState === WebSocket.OPEN) {
      socket?.send(JSON.stringify({ action: "PING" }));
    }
  }, HEARTBEAT_INTERVAL);
};

const stopHeartbeat = () => {
  clearInterval(heartbeatInterval);
  heartbeatInterval = null;
};

/* ============================================================
   CONNECT (SINGLE INSTANCE)
============================================================ */
const connectWebSocket = (userId) => {
  if (socket?.readyState === WebSocket.OPEN || isConnecting) return socket;

  isConnecting = true;

  socket = new WebSocket(
    `wss://cwlub0r6p0.execute-api.us-east-1.amazonaws.com/dev?userId=${userId}`,
  );

  socket.onopen = () => {
    isConnecting = false;
    socket?.send(
      JSON.stringify({
        type: "CLIENT_READY",
        userId,
      }),
    );

    startHeartbeat();
    flushMessageQueue();
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (data.action === "PING") {
        return;
      }
      if (data.type === "DELIVERED_ACK") {
        return;
      }

      if (data.type === "CHAT") {
        store.dispatch(setIsLiveMsg(data));
        store.dispatch(setIsLiveMsgNotification(data));

        sendDeliveredAck({
          messageId: data.messageId,
          fromUserId: data.fromUserId,
        });
      }
    } catch (err) {
      console.error("Invalid WS message:", err);
    }
  };

  socket.onerror = (err) => {
    console.error("WS ERROR:", err);
  };

  socket.onclose = () => {
    console.warn("WS CLOSED – reconnecting...");
    cleanupSocket();

    const token = localStorage.getItem("token");
    if (token) {
      reconnectTimeout = setTimeout(
        () => connectWebSocket(userId),
        RECONNECT_DELAY,
      );
    }
  };

  return socket;
};

/* ============================================================
   CLEANUP
============================================================ */
const cleanupSocket = () => {
  stopHeartbeat();
  clearTimeout(reconnectTimeout);

  socket = null;
  isConnecting = false;
};

/* ============================================================
   QUEUE HANDLING
============================================================ */
const flushMessageQueue = () => {
  while (messageQueue.length && socket?.readyState === WebSocket.OPEN) {
    const msg = messageQueue.shift();
    socket?.send(JSON.stringify(msg));
  }
};

/* ============================================================
   SEND CHAT MESSAGE
============================================================ */
export const sendMessage = ({
  fromUserId,
  toUserId,
  productId,
  bookingId,
  campaignId,
  message,
}) => {
  console.log("Arguments received:", {
    fromUserId,
    toUserId,
    productId,
    bookingId,
    campaignId,
    message,
  });
  const payload = {
    type: "CHAT",
    fromUserId,
    toUserId,
    ...(productId && {
      productId,
    }),
    ...(bookingId && {
      bookingId,
    }),

    ...(campaignId && {
      campaignId,
    }),
    ...(message && {
      message,
    }),
    jwtToken: localStorage.getItem("token"),
  };
  if (!socket || socket.readyState !== WebSocket.OPEN) {
    messageQueue.push(payload);
    return;
  }

  socket?.send(JSON.stringify(payload));
};

/* ============================================================
   SEND DELIVERY ACK
============================================================ */
const sendDeliveredAck = ({ messageId, fromUserId }) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return;

  socket?.send(
    JSON.stringify({
      type: "DELIVERED_ACK",
      messageId,
      fromUserId,
    }),
  );
};

/* ============================================================
   MANUAL DISCONNECT
============================================================ */
export const disconnectWebSocket = () => {
  cleanupSocket();
  socket?.close();
};

// export const sendTermsRequest = ({
//   fromUserId,
//   toUserId,
//   productId,
//   bookingId,
//   campaignId,

//   product_booking_id,
//   request_type,
//   calendar_data,
//   percentage_data,
//   desc,
// }) => {
//   sendMessage({
//     fromUserId,
//     toUserId,
//     productId,
//     bookingId,
//     campaignId,
//     // Terms Request data
//     product_booking_id,
//     request_type,
//     calendar_data,
//     percentage_data,
//     desc,
//   });
// };

/* ============================================================
   EXPORT CONNECT
============================================================ */
export { connectWebSocket };
